import { Line, LineChart, ReferenceDot, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { StrikeStats } from "./StrikeStats";

const day = (t) => new Date(t * 1000).toLocaleString([], { weekday: "short", hour: "2-digit", minute: "2-digit" });
const mv = (v) => (v == null ? "—" : `${v >= 0 ? "+" : "-"}$${Math.abs(v).toFixed(2)}`);

export const ConflictTimeline = ({ data }) => {
  if (!data?.series?.length) return null;
  return (
    <section className="desk-card" data-testid="desk-conflict-timeline">
      <h2>Gold vs strike headlines · last 5 days</h2>
      <div className="h-52 -mx-2">
        <ResponsiveContainer>
          <LineChart data={data.series}>
            <XAxis dataKey="t" type="number" domain={["dataMin", "dataMax"]} tickFormatter={(t) => new Date(t * 1000).toLocaleDateString([], { weekday: "short" })} stroke="#8A8778" fontSize={12} tickLine={false} axisLine={false} />
            <YAxis domain={["dataMin - 5", "dataMax + 5"]} stroke="#8A8778" fontSize={12} width={48} tickLine={false} axisLine={false} tickFormatter={(v) => Math.round(v)} />
            <Tooltip contentStyle={{ background: "#141511", border: "1px solid #26281f", color: "#ECE8DC" }} labelFormatter={day} formatter={(v) => [`$${v}`, "Gold"]} />
            <Line dataKey="v" stroke="#D4A940" strokeWidth={2} dot={false} isAnimationActive={false} />
            {data.marks.map((m, i) => <ReferenceDot key={`${m.t}-${i}`} x={m.t} y={m.v} r={6} fill="#E5484D" stroke="#0B0C0A" strokeWidth={2} />)}
          </LineChart>
        </ResponsiveContainer>
      </div>
      <StrikeStats stats={data.stats} />
      {data.marks.length === 0 ? <p className="text-base text-[color:var(--mute)] mt-2" data-testid="desk-ct-empty">No strength 4–5 strike headlines during market hours in the last 5 days.</p> : (
        <ul className="mt-3" data-testid="desk-ct-list">
          {data.marks.map((m, i) => (
            <li key={`${m.t}-${i}`} className="flex gap-3 py-2 border-b border-[color:var(--line)] last:border-none text-base" data-testid={`desk-ct-${i}`}>
              <span className="w-2.5 h-2.5 rounded-full bg-[color:var(--red)] mt-2 shrink-0" />
              <div className="flex-1 min-w-0">
                <div className="font-semibold leading-snug">{m.title}</div>
                <div className="desk-mono text-sm text-[color:var(--mute)]">{day(m.t)} · ${m.v} · 1h after: <span className={m.move_1h == null ? "" : m.move_1h >= 0 ? "desk-up" : "desk-down"}>{mv(m.move_1h)}</span></div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};
